import React, {useContext, useState} from 'react';
import PropTypes from "prop-types";
import * as Yup from "yup";
import {ParametersContext} from "../../store/context";
import {TableInEdit} from "../utils/tables";
import {useFormContext} from "react-hook-form";
import {FormCheckbox, FormGroup, FormSelect} from "../../components/form";

FieldsUniteEnseignement.schema = Yup.object({
    LibelleUE: Yup.string().required().label("Libelle"),
    LibelleUEEN: Yup.string().nullable().notRequired().label("Libelle EN"),
    NbECTS: Yup.number().required().integer().label("Nombre d'ECTS"),
    NbHeures: Yup.number().required().integer().label("Nombre d'heures"),
    ModaliteID: Yup.number().required().positive().integer().label("Modalité"),
    LieuEnseignementID: Yup.number().required().positive().integer().label("Lieu d'enseignement"),
    TypeMoyennePonderationID: Yup.number().required().positive().integer().label("Type de moyenne"),
}).required()

function FieldsUniteEnseignement(props) {
    const {parameters} = useContext(ParametersContext);
    const ueaa = `UniteEnseignementAnneeAcademiqueID-${props.data.AnneeAcademiqueID}`;
    const [intervenants, setIntervenants] = useState(props.data.Intervenants);
    const {control, register} = useFormContext();

    return <>
        <FormGroup name={"LibelleUE"} label={"Libelle"} rules={{required: true}}/>
        <FormGroup name={"LibelleUEEN"} label={"Libelle EN"} rules={{required: false}}/>
        <FormGroup name={"NbECTS"} label={"ECTS"} rules={{required: true}}/>
        <FormGroup name={"NbHeures"} label={"Heures"} rules={{required: true}}/>
        <FormGroup name={"ModaliteID"} label={"Modalité"} type={FormSelect}
                   options={parameters.p.ModaliteID} rules={{required: true}}/>
        <FormGroup name={"LieuEnseignementID"} label={"Lieu d'enseignement"} type={FormSelect}
                   options={parameters.p.LieuEnseignementID} rules={{required: true}}/>
        <FormGroup name={"TypeMoyennePonderationID"} label={"Type de moyenne"} type={FormSelect}
                   options={parameters.p.TypeMoyennePonderationID} rules={{required: true}}/>
        <FormCheckbox name={"IsMemoire"} label={"Mémoire"} edit={true}/>
        <FormCheckbox name={"IsAnglais"} label={"En anglais"} edit={true}/>
        <FormCheckbox name={"AANeutralisable"} label={<>Est-ce que certaines activités d'apprentissages doivent être neutralisées ?</>} edit={true}/>

        {[
            {
                "columns": {
                    "Enseignant": i => i.MembrePersonnel.Display,
                    "Responsable": (i) =>
                        <FormCheckbox {...register(`Intervenants[${intervenants.indexOf(i)}][IntervenantResponsable]`)}
                                      control={control}
                                      checked={i.IntervenantResponsable}
                                      edit={true}
                                      onChange={x => {
                                          intervenants.find(f => f.MembrePersonnel.ID === i.MembrePersonnel.ID).IntervenantResponsable = x;
                                          setIntervenants([...intervenants])
                                      }}
                                      name={`Intervenants[${intervenants.indexOf(i)}][IntervenantResponsable]`}
                        />
                },
                "field": "Intervenants",
                "onChange": x => {
                    x.map(m => m['IntervenantResponsable'] = m['IntervenantResponsable'] || false);
                    setIntervenants(x);
                    setTimeout(() => console.log(intervenants), 2000);
                },
                "param": "MembrePersonnelID",
                "emptyValue": "MembrePersonnel"
            }, {
                "columns": {"Niveau de cours": x => x.NiveauCours.Display},
                "field": "NiveauxCoursUnitesEnseignement",
                "param": "NiveauCoursID",
                "emptyValue": "NiveauCoursUniteEnseignement"
            }, {
                "name": "UniteEnseignementRequis",
                "columns": {"Prérequis": x => x["UniteEnseignementRequis"].Display},
                "field": "PrerequisMaitres",
                "param": `${ueaa}`,
                "emptyValue": "Prerequis",
                "excludeIDs": [props.data.ProgrammeEffectifID]
            }, {
                "name": "UniteEnseignementRequis",
                "columns": {"Corequis": x => x["UniteEnseignementRequis"].Display},
                "field": "CorequisMaitres",
                "param": `${ueaa}`,
                "emptyValue": "Corequis",
                "excludeIDs": [props.data.ProgrammeEffectifID]
            }, {
                "name": "UniteEnseignementRequis",
                "columns": {"Incompatibles": x => x["UniteEnseignementRequis"].Display},
                "field": "IncompatiblesMaitres",
                "param": `${ueaa}`,
                "emptyValue": "Incompatible",
                "excludeIDs": [props.data.ProgrammeEffectifID]
            }, {
                "columns": {"Familles": x => x.FamilleUniteEnseignement.Display},
                "field": "FamillesUniteEnseignementUnitesEnseignement",
                "param": "FamilleUniteEnseignementID",
                "emptyValue": "FamilleUniteEnseignementUniteEnseignement"
            }, {
                "columns": {"Groupements": x => x.GroupementUniteEnseignement.Display},
                "field": "GroupementsUniteEnseignementUnitesEnseignement",
                "param": "GroupementUniteEnseignementID",
                "emptyValue": "GroupementUniteEnseignementUniteEnseignement"
            },
        ].map((s, k) => {
            return <TableInEdit
                key={k}
                columns={s.columns}
                columnsExport={Object.values(s.columns)}
                fieldName={s.field}
                parameters={s.param}
                name={s.name}
                onChange={s.onChange}
                excludeIDs={s.excludeIDs ?? []}
                emptyValues={s.emptyValue}
                values={props.data[s.field]}/>
        })}
    </>;
}

FieldsUniteEnseignement.propTypes = {
    data: PropTypes.object.isRequired,
}

export default FieldsUniteEnseignement;